export const inr = (n, opts = {}) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("en-IN", {
    style: "currency", currency: "INR",
    maximumFractionDigits: opts.decimals ?? 0, minimumFractionDigits: opts.decimals ?? 0,
  }).format(v);
};

export const inrCompact = (n) => {
  const v = Number(n || 0);
  if (Math.abs(v) >= 10000000) return `₹${(v / 10000000).toFixed(2)} Cr`;
  if (Math.abs(v) >= 100000) return `₹${(v / 100000).toFixed(2)} L`;
  return inr(v);
};

export const num = (n) => new Intl.NumberFormat("en-IN").format(Number(n || 0));

export const fmtDate = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const initials = (name = "") =>
  name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const AVATARS = [
  "https://images.unsplash.com/photo-1753806901748-4c39b4512d5d?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
  "https://images.unsplash.com/photo-1753806901564-ddd061ca871e?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
  "https://images.unsplash.com/photo-1753806901294-bb48ab9bede2?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
];
